import http from "./http-common";

class CriticalityService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  // CriticalityCount(payload) {
  //   const queryString = new URLSearchParams(payload).toString();
  //   return http.get(`PatientClinicalStatus/clinicalStatusCount?${queryString}`);
  // }
  CriticalityCount(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/PatientClinicalStatus/getClinicalStatusCountDetails?${queryString}`
    );
  }
}
export default new CriticalityService();
